import type { Dispatch, SetStateAction } from 'react';

type ImportQueueRow = {
  clientId: string;
  status: string;
  errorMessage?: string;
};

/** Re-queue a failed import row and run the import executor on the next tick. */
export function scheduleImportQueueRowRetry<TRow extends ImportQueueRow>(args: {
  clientId: string;
  queue: TRow[];
  setQueue: Dispatch<SetStateAction<TRow[]>>;
  toQueuedRow: (row: TRow) => TRow;
  execute: (row: TRow) => void | Promise<void>;
}): boolean {
  const row = args.queue.find(item => item.clientId === args.clientId);
  if (!row) {
    return false;
  }

  const refreshed = args.toQueuedRow(row);

  args.setQueue(prev =>
    prev.map(item =>
      item.clientId === args.clientId
        ? ({ ...item, status: 'queued', errorMessage: undefined } as TRow)
        : item
    )
  );

  queueMicrotask(() => {
    void args.execute(refreshed);
  });

  return true;
}
